var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"fts-form-label",class:[
    {'with-icon': _vm.icon},
    {'form-label--top': _vm.placement === 'top'},
    {'form-label--left': _vm.placement === 'left'},
    {'form-label--icon-right': _vm.iconRight},
    {'form-label--nowrap': !_vm.textWrap},
    {'form-label--comfort': _vm.comfortDesign},
    {'form-label--required': _vm.required},
    {'form-label--error': _vm.error},
    {'form-label--py': _vm.maintainLabelHeight}
  ]},[(_vm.icon || Boolean(_vm.$slots.icon) || Boolean(_vm.$scopedSlots.icon))?_c('div',{staticClass:"form-label__icon"},[_vm._t("icon",function(){return [_c('i',{class:_vm.icon})]})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-label__label"},[_vm._t("default")],2),_vm._v(" "),(Boolean(_vm.$slots.suffix))?_c('div',{staticClass:"form-label__suffix"},[_vm._t("suffix")],2):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }